import { ReduxRouterSelector } from '@lagunovsky/redux-react-router';
import { IRouterStoreSegment } from './router.interface';

export const routerStoreSelector: ReduxRouterSelector = (state: IRouterStoreSegment) => state.router;
